import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import { siteInfo } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function FeaturedSection() {
  const featuredComics = comics.filter(c => c.featured).slice(0, 4);

  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            编辑精选
          </span>
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950">
            本周热门推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            精挑细选，不容错过的优质韩漫
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuredComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} variant="featured" />
          ))}
        </div>
      </div>
    </section>
  );
}